// extracted by mini-css-extract-plugin
export default {"popoverAnchor":"styles_popover-anchor__ycoub","logo":"styles_logo__2i0Tw","header":"styles_header__CSBzw","heading":"styles_heading__P5rRi"};